import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Globals } from '../service/global';
import { UtilityService } from '../service/utility.service';

@Pipe({
  name: 'safeMinutes'
})
export class SafeMinutesPipe implements PipeTransform {

  constructor(private sanitized: DomSanitizer,private utilService:UtilityService,private globals:Globals) { }

  transform(minAttrList:any) {
    return this.constructTaskSec(minAttrList);
  }
  //Method to construct task secti[uon
  constructTaskSec(minAttrList: any) {
 
    var tempHtml = "<br>";
    if(minAttrList!=null && minAttrList!=undefined){
      tempHtml=this.utilService.nvl(minAttrList.taskTitle); 
      //actionItemOwner":[{"fkSecUserOwner":523,"fkCodelstStatus":16,"ismailsent":1,"actionItemActualComplDate":null,"ownerName":"Mahalakshmi S"}],"actionType":null,"minutesId":834,"noteDescription":"","createdByName":"Mahalakshmi S","shortName":null}]
      if((minAttrList.actionItemOwner!=null && minAttrList.actionItemOwner!=undefined && minAttrList.actionItemOwner.length>0) || (this.utilService.nvl(minAttrList.guestOwnerName)!="")){
          tempHtml+='<span class="assignCls" contenteditable="false">Owner(s): </span>';
      }
      if(minAttrList.actionItemOwner!=null && minAttrList.actionItemOwner!=undefined){        
        minAttrList.actionItemOwner.forEach((actionItemOwnerList: any, index: any) => {
          tempHtml+='<span class="atwho-inserted" data-atwho-at-query="@" id="'+actionItemOwnerList.fkSecUserOwner+'" fkuserid="'+actionItemOwnerList.fkSecUserOwner+'" contenteditable="false">'+actionItemOwnerList.ownerName;
          if((minAttrList.actionItemOwner?.length>1) && (index!=minAttrList.actionItemOwner?.length-1)){
            tempHtml+=",";
          }
          tempHtml+="</span>&nbsp;";
        });
      }
      if(this.utilService.nvl(minAttrList.guestOwnerName)!=""){
        //
        String(minAttrList.guestOwnerName).split(",").forEach((guestName:any) => {
          // //
          // tempHtml+='<span class="atwho-inserted" data-atwho-at-query="@" id="" contenteditable="false">'+guestName+'</span>&nbsp;,';
        });
      }
      if(this.utilService.nvl(minAttrList.dueDateStr)!=""){
        tempHtml+='<span contenteditable="false" class="minDateCls"><span class="dueLabelCls">Due Date: &nbsp;</span>'+minAttrList.dueDateStr;
        if (this.globals.showTimezone_Date != null && this.globals.showTimezone_Date=="Y") {
          tempHtml+='<span class="taskTimezoneCls"> '+this.globals.vShortTimeZone+'</span>';
        }
        tempHtml+='</span>&nbsp;';
      }
    }
    return this.sanitized.bypassSecurityTrustHtml(tempHtml);
  }
}
